

(function() {
  const initFeedbackSlider = () => {
    const feedback_sliders = document.querySelectorAll('.carousel__slider-sus-feedback');
    feedback_sliders.forEach((slider, index) => {

      const feedbackSlider = new Swiper(slider, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 8,
        watchSlidesProgress: true,
        simulateTouch: true, 
        autoHeight: true,
        speed: 500,
        loop: true,
        pagination: {
          el: '.product__pagination-wrapper .swiper-pagination',
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
            800: {
                slidesPerView: 2, 
                slidesPerGroup: 2
            }, 
        },
      })
    })
  }
  initFeedbackSlider();
})()